const menuPerms = {
  "Navigation menu": [
    "Chargeur Principal",
    "Sous Compte Chargeur",
    "Chargeur Secondaire",
    "Vérificateur",
    "Validateur",
    "Vérificateur Regule",
    "Validateur Regule",
    "Validateur Transit",
    "Authentificateur",
    "Helpdesk",
    "Comptabilité",
    "Administrateur",
    "Modificateur",
    "Statistiques",
    "Imprimeur",
    "Operation",
  ],
  "Tableau De Bord": ["Chargeur Principal", "Sous Compte Chargeur"],
  Chargeur: ["Helpdesk", "Administrateur", "Modificateur"],
  CodeSH: ["Helpdesk", "Administrateur", "Modificateur"],
  Devise: ["Helpdesk", "Administrateur", "Modificateur"],
  Fournisseur: ["Helpdesk", "Administrateur", "Modificateur"],
  Incoterm: ["Helpdesk", "Administrateur", "Modificateur"],
  Marque: ["Helpdesk", "Administrateur", "Modificateur"],
  Modèle: ["Helpdesk", "Administrateur", "Modificateur"],
  Navire: ["Helpdesk", "Administrateur", "Modificateur"],
  Pays: ["Helpdesk", "Administrateur", "Modificateur"],
  Port: ["Helpdesk", "Administrateur", "Modificateur"],
  Transporteur: ["Helpdesk", "Administrateur", "Modificateur"],
  Ville: ["Helpdesk", "Administrateur", "Modificateur"],
  BESC: [
    "Chargeur Principal",
    "Sous Compte Chargeur",
    "Chargeur Secondaire",
    "Vérificateur",
    "Validateur",
    "Vérificateur Regule",
    "Validateur Regule",
    "Validateur Transit",
    "Authentificateur",
    "Administrateur",
    "Modificateur",
    "Imprimeur",
    "Statistiques",
    "Operation",
  ],
  HelpDesk: ["Helpdesk", "Administrateur", "Modificateur"],
  "Créer un BESC": [
    "Chargeur Principal",
    "Sous Compte Chargeur",
    "Chargeur Secondaire",
  ],
  Maritime: [
    "Chargeur Principal",
    "Sous Compte Chargeur",
    "Chargeur Secondaire",
  ],
  Aérien: ["Chargeur Principal", "Sous Compte Chargeur", "Chargeur Secondaire"],
  Terrestre: [
    "Chargeur Principal",
    "Sous Compte Chargeur",
    "Chargeur Secondaire",
  ],
  Import: ["Chargeur Principal", "Sous Compte Chargeur", "Chargeur Secondaire"],
  Export: ["Chargeur Principal", "Sous Compte Chargeur", "Chargeur Secondaire"],
  Regule: ["Chargeur Principal", "Sous Compte Chargeur", "Chargeur Secondaire"],
  Transit: [
    "Chargeur Principal",
    "Sous Compte Chargeur",
    "Chargeur Secondaire",
  ],
  "Liste des BESCs": [
    "Administrateur",
    "Modificateur",
    "Imprimeur",
    "Operation",
    "Statistiques",
  ],
  "BESC Import": ["Vérificateur", "Validateur", "Authentificateur"],
  "BESC Export": ["Validateur", "Authentificateur"],
  "BESC Regul": ["Vérificateur", "Validateur"],
  "BESC Transit": ["Validateur Transit"],
  ["Mes BESCs"]: [
    "Chargeur Principal",
    "Sous Compte Chargeur",
    "Chargeur Secondaire",
  ],
  Facturation: [
    "Chargeur Principal",
    "Comptabilité",
    "Operation",
    "Administrateur",
  ],
  Approvisionnement: ["Chargeur Principal"],
  "Liste des demandes d'approvisionnement": [
    "Chargeur Principal",
    "Comptabilité",
  ],
  "Débit/crédit manuel d'un compte": ["Operation", "Administrateur"],
  ["Tous les BESCs"]: [
    "Chargeur Principal",
    "Vérificateur",
    "Validateur",
    "Vérificateur Regule",
    "Validateur Regule",
    "Authentificateur",
    "Validateur Transit",
  ],
  "Liste des redressements": ["Comptabilité"],
  Redressements: ["Operation"],
  Exonerations: ["Operation"],
  Annulations: ["Operation"],
  "Historique des BESCs": [
    "Vérificateur",
    "Validateur",
    "Vérificateur Regule",
    "Validateur Regule",
    "Authentificateur",
    "Validateur Transit",
  ],
  ["Configuration"]: ["Chargeur Principal"],
  Configuration: ["Chargeur Principal"],
  "Gestion des sous comptes": ["Chargeur Principal"],
  Statistiques: [
    "Chargeur Principal",
    "Sous Compte Chargeur",
    "Administrateur",
    "Consultant",
    "Operation",
    "Statistiques",
    "Comptabilité",
  ],
  Statistiques_chargeur: ["Chargeur Principal", "Sous Compte Chargeur"],
  Mouvement_chargeur: ["Chargeur Principal", "Sous Compte Chargeur"],
  Statistiques_cncc: [
    "Administrateur",
    "Consultant",
    "Operation",
    "Comptabilité",
  ],
  Statistiques_perf: ["Operation"],
  Statistiques_ot: ["Statistiques"],
  Mouvement_cncc: [
    "Administrateur",
    "Consultant",
    "Operation",
    "Statistiques",
    "Comptabilité",
  ],
  Audit: ["Administrateur", "Operation"],
};

const getPerms = (content, role) => {
  let _res = [];

  let _content = content.filter((l) => menuPerms[l.label]);

  _content.map((l) => {
    if (role.user && menuPerms[l.label].includes(role.user.roles[0].name)) {
      _res.push(l);
    }
  });

  return _res;
};

const getPerms2 = (list, label, role) => {
  if (
    role &&
    role.user &&
    role.user.company &&
    role.user.company.account_category == 0 &&
    label === "Configuration"
  ) {
    return false;
  }
  let op = role && role.user && role.user.company.operations;

  if (
    [
      "Facturation",
      "Tous les BESCs",
      "Configuration",
      "Approvisionnement",
      "Liste des demandes d'approvisionnement",
      "Gestion des sous comptes",
    ].includes(label) &&
    ["Chargeur Principal"].includes(role.user.roles[0].name) &&
    role.user.main_user == 1
  ) {
    return true;
  }

  if (
    role &&
    role.user &&
    role.user.company &&
    ["Maritime", "Aérien", "Terrestre"].includes(label)
  ) {
    let obj = op.find((item) => item.transport_mode.includes(label.charAt(0)));
    return !!obj;
  }

  let role_permissions =
    role &&
    role.user &&
    menuPerms[label] &&
    menuPerms[label].includes(role.user.roles[0].name);
  // console.log("label : ", label);
  // console.log("menuPerms.label : ", menuPerms[label]);
  // console.log("role : ", role.user.roles[0].name);

  let transport_permissions = true;

  if (list.origin) {
    let obj = op.find((item) => item.traffic_direction === label);
    let c = list.origin.charAt(0);
    if (obj) {
      transport_permissions = obj.transport_mode.includes(c);
    } else {
      transport_permissions = false;
    }
  }

  return transport_permissions && role_permissions;
};

export { menuPerms, getPerms, getPerms2 };
